import { EntityId } from '@reduxjs/toolkit'

export const CompartmentChangeStateEnum = {
  Unchanged: 0,
  Added: 1,
  Deleted: 2,
  Modified: 3,
}

export type CompartmentChangeState = typeof CompartmentChangeStateEnum[keyof typeof CompartmentChangeStateEnum]

export type Compartment = {
  id: EntityId
  groupId: EntityId
  compartmentDefinitionId: EntityId
  attributeIds: EntityId[]
  state: CompartmentChangeState
  isActive: boolean
  name: string
  volumeCapacity: number
}
